
<template>
  <div class="Omoss" id="back1">

<div>
   <b-container align="center"  >
 
  <b-card-group columns >
 

    <b-card align="center"  cols="4"  v-for="item in items" :key="item.id"  text-variant="white"   style="background:  rgb(151, 130, 37); max-width: 25rem;min-width: 25rem;" >
          <b-card-img
                :src="item.bilde"
                style="max-width: 20rem;min-width: 20rem;min-height: 25rem;max-height:25rem;"
                class="rounded-2" align="center" 
              ></b-card-img>
              <b-card-body align="center" style="max-height: 14rem;min-height: 14rem;">
 <b-card-title>{{item.navn}}</b-card-title>
               <b-card-text>Stilling : {{item.Stilling}}</b-card-text>
                <b-card-text>{{item.beskrivelse}}</b-card-text>
               <b-card-text v-if="item.mobilhar"> {{item.mobil}}</b-card-text>
               <b-card-text v-if="item.mobilhar"> {{item.email}}</b-card-text>
               </b-card-body>
</b-card>



</b-card-group>
</b-container>
</div>



   
  </div>
</template>

<script>


const items = [
  {
    id: 0,
    navn: "Enok Jakobsen",
    Stilling: "Daglig leder, Medeier og tømrer",
    beskrivelse: "Han har 30 års erfaring innen tømrerfaget.",
    mobil: "Mobil 41300069",
    email: "enok@askoytomrer.no",
    bilde: require("../assets/Bilder/Ansatte/Enok.jpg"),
    mobilhar: true
  },
  {
    id: 1,
    navn: "Ramunas Bruzinskas",
    Stilling: "Medeier og tømrer",
    beskrivelse: "Han har 10 års erfaring innen tømrerfaget.",
    mobil: "Mobil 41237217",
    email: "ramunas@askoytomrer.no",
    bilde: require("../assets/Bilder/Ansatte/Ramunas_B.jpg"),
     mobilhar: true
  },
  {
    id: 2,
    navn: "Ramunas Galdikas",
    Stilling: "Medeier og tømrer",
    beskrivelse: "Han har 10 års erfaring innen tømrerfaget.",
    mobil: "",
    email: "",
    bilde: require("../assets/Bilder/Ansatte/Ramunas_G.jpg"),
     mobilhar: false
  }
];

export default {
  data() {
    return {
      items: items,
      img: {
        buy: require("../assets/Bilder/Ansatte/Enok.jpg")
      }
    };
  },
  
};
</script>


<style  scoped>
.card-group .card {
    max-width: 100%;

  
}
.b-card-group  {
   

    columns:false;
}

</style>


